import { CHEERS_UP_DISCORD_URL } from "@/constants/index";
import { useRouter } from "next/router";
import { BlueLink } from "../BlueLink";

const En = () => {
  return (
    <div>
      Please visit official Cheers UP discord, open a ticket, and @Terrry#1904
      to get your codes. Thanks!
      <br />
      <br />
      Link:{" "}
      <BlueLink href={CHEERS_UP_DISCORD_URL}>{CHEERS_UP_DISCORD_URL}</BlueLink>
    </div>
  );
};

const Cn = () => {
  return (
    <div>
      请光顾Cheers UP的官方discord开票@Terrry#1904获取兑换码，感谢！
      <br />
      <br />
      Discord链接：
      <BlueLink href={CHEERS_UP_DISCORD_URL}>{CHEERS_UP_DISCORD_URL}</BlueLink>
    </div>
  );
};

export const SuccessContent = () => {
  const { locale } = useRouter();

  return (
    <div className="text-[14px] font-normal leading-[24px]">
      {locale === "cn" ? <Cn /> : <En />}
    </div>
  );
};
